import { forwardRef, useEffect } from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogContent,
  Grid,
  Typography,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import { useDispatch, useSelector } from "react-redux";
import {
  setTypesDialog,
  resetForm,
  ExpenseTypes,
} from "../../../../../app/slices/expenseTypesSlice";
import { Controller, useForm } from "react-hook-form";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ExpenseTpesForm = () => {
  const _ExpenseTypes = useSelector((state) => state.expenseTypes.expenseTypes);
  const _SearchBody = useSelector((state) => state.expenseTypes.searchBody);

  const isAdd = _ExpenseTypes.form.id ? false : true;
  const { control, handleSubmit } = useForm({
    defaultValues: _ExpenseTypes.form,
  });


  const onSubmit = (data) => {
    if (isAdd) {
      dispatch(ExpenseTypes.create(data));
    } else {
      dispatch(ExpenseTypes.update(data.id, data, _SearchBody));
    }
  };
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
  }, [dispatch]);


  const handlDialog = () => {
    dispatch(setTypesDialog());
  };

  return (
    <Dialog
      open={_ExpenseTypes.dialog}
      TransitionComponent={Transition}
      keepMounted
      fullWidth={true}
      dir="rtl"
      onClose={() => {
        handlDialog();
      }}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogContent>
        <Typography
          mb={3}
          variant="h4"
          color={"purple"}
          gutterBottom
          component="div"
        >
          {isAdd ? "أضافة " : "تعديل "}
        </Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Controller
                name="name"
                control={control}
                render={({ field }) => (
                  <TextField
                    required
                    size="small"
                    label="الاسم"
                    fullWidth
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Button type="submit" variant="contained" color="primary">
                حفظ
              </Button>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ExpenseTpesForm;
